<template>
    <div class="createDistrict">
        <v-dialog v-model="dialog" max-width="80vw">
            <v-card>
                <v-form @submit.prevent="createData" ref="form">
                    <v-card-title>
                    <span class="headline">Tạo quận</span>
                    </v-card-title>
                    <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                :rules="rules.codeRules"
                                v-model="form.Code"
                                label="Mã"
                                placeholder="Mã tự sinh nếu để trống"
                                readonly
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-autocomplete
                                    v-model="form.cityCode"
                                    :items="formData.cities"
                                    chips
                                    small-chips
                                    label="Thành phố"
                                    item-text="name"
                                    item-value="code"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                :rules="rules.nameRules"
                                v-model="form.Name"
                                label="Tên"
                                required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="dialog = false"
                    >
                        Thoát
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        type="submit"
                    >
                        Lưu
                    </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common'
export default {
    name: "DistrictCreateDialog",
    components:{

    },
    data() {
        return {
            //*************** Validate **************
            rules: {
                nameRules:[ 
                    v => !!v || 'Tên bắt buộc nhập',
                    v => v.length > 3 || 'Phải nhiều hơn 3 kí tự',
                ],
                codeRules:[ 
                    v => v ? v.length > 3 || 'Phải nhiều hơn 3 kí tự': true,
                ],
            },
            
            //************* Form config */
            rootUrl: "districts",
            FETCH_CITY_URL: "cities/fetch",
            valid: false,
            item: undefined,
            isUpdate: false,
            dialog: false,
            IDdateMenu: false,
            HireMenu: false,
            formData: {
                cities: []
            },
            form: {
                Code: "",
                Name:"",
                cityCode: "",
            },
            defaultForm: {
                Code: "",
                Name:"",
                cityCode: "",
            },
        };
    },
    computed: {
        formTitle(){
            return this.isUpdate ? "Cập nhật thành phố" : "Tạo mới thành phố";
        }
    },
    watch: {
        dialog (val) {
            val || this.close();
        },
    },
    methods: {
        fetchUpdate (){
            http.get(this.rootUrl + "/"+ this.item.code).then(res => {
                let data = res.data;
                this.form.cityCode = data.cityCode;
                this.form.Name = data.name;
                this.form.Code = data.code;
                console.log(data)
            }).catch(err => {
                console.log(err);
            });
        },
        close () {
            this.dialog = false;
            this.isUpdate = false;
            this.$refs.form.resetValidation();
            this.form = Object.assign({}, this.defaultForm);
        },
        fetchCities() {
            http.get(this.FETCH_CITY_URL).then(res => {
                this.formData.cities = res.data;
            }).catch(err =>{
                console.log("error connection");
            });
        },
        createData () {
            this.$refs.form.validate()
            if(!this.isUpdate)
                http.post(this.rootUrl + "/", this.form).then(res => {
                    this.dialog = false;
                    this.$emit("needFetch");
                }).catch( (err) => {
                    console.log(err.response.status);
                })
            else{
                http.put(this.rootUrl + '/' + this.item.code, this.form).then(res => {
                    this.dialog = false;
                    this.$emit("needFetch");
                }).catch( (err) => {
                    console.log(err.response.status);
                })
            }
        }
    },
    mounted() {
        this.fetchCities();
    }
}
</script>
